import { ReactElement } from 'react';
import { SnackbarProps as MuiSnackbarProps } from '@material-ui/core/Snackbar';
import { IconProps } from '../Icon';

export interface SnackbarProps extends MuiSnackbarProps {
  semantic?: 'warning' | 'info' | 'success' | 'error';
  transitionDirection: 'left' | 'right' | 'up' | 'down';
  title: string;
  MessageIcon: ReactElement<IconProps>;
  showSemanticIcon: boolean;
}

export interface SnackbarContentProps
  extends Pick<
    SnackbarProps,
    | 'message'
    | 'action'
    | 'title'
    | 'semantic'
    | 'MessageIcon'
    | 'showSemanticIcon'
  > {}

export enum Semantic {
  'WARNING' = 'warning',
  'INFO' = 'info',
  'SUCCESS' = 'success',
  'ERROR' = 'error'
}

export enum Direction {
  'UP' = 'up',
  'DOWN' = 'down',
  'LEFT' = 'left',
  'RIGHT' = 'right'
}
